import graphqlClient from '../../api/axios_interceptor';
import { 
    AddLandlordMutation, UpdateLandlordMutation,DeleteLandlordMutation, GetLandlordsQuery
} from '../../api/graphql/queries/landlord';
import { ADD_LANDLORD, UPDATE_LANDLORD, DELETE_LANDLORD, FETCH_LANDLORDS
} from '../actions/actionTypes';
import { updateActionErrors } from './updateErrors';
import { FormDataRestClient } from '../../api/rest_interceptor';
import { GRAPHQL_API } from '../../api/graphql/endpoint';
import { getFormData } from './functions';

const parseFetchLandlord = (landlord) => ({
    landlordId: landlord.id,
    firstName: landlord.user.firstName,
    lastName: landlord.user.lastName,
    email: landlord.user.email,
    phoneNumber: landlord.user.phoneNumber,
    propertyIds: landlord.properties.map((item, index) => item.id),
    nationalIdNumber: landlord.user.nationalIdNumber,
    notes: landlord.notes,
    disbursementDate:  landlord.disbursementDate,
    nextKinName: landlord.nextKinName,
    nextKinPhoneNumber: landlord.nextKinPhoneNumber,
    kraPin: landlord.kraPin,
    // fileName: landlord.uploads.map((item, index) => item.name),//to be fixed
    // fileId: landlord.uploads.map((item, index) => item.id),//to be fixed
})

const addLandlordsMiddleware = async (action) => {
    try {
        let landlord = action.payload;
        const query = AddLandlordMutation(
            landlord.email, landlord.firstName, landlord.lastName,
            landlord.phoneNumber, landlord.nextKinName, 
            landlord.disbursementDate, landlord.kraPin, landlord.notes,
            landlord.propertyIds, landlord.nationalIdNumber, landlord.nextKinPhoneNumber
        );
        const formData = getFormData(query, action.payload.fileUpload);

        await FormDataRestClient.post(
            GRAPHQL_API, formData
        ).then((queryResult) => {
            if (queryResult.data.errors) {
                action = updateActionErrors(action, queryResult.data.errors);
            }else if(queryResult.data.data.addLandlord.errorMessage){
                action = updateActionErrors(action, queryResult.data.data.addLandlord.errorMessage);
            } else {
                let modPayload = {
                    ...action.payload,
                    ...queryResult.data.data.addLandlord.landlord
                }

                action = {
                    ...action,
                    payload: parseFetchLandlord(modPayload)
                };
            }
        });
    } catch (error) {
        console.error(error);
        action = updateActionErrors(action, error)
    }
    return action;
}

const updateLandlordsMiddleware = async (action) => {
    try {
        let landlord = action.payload;
        const query = UpdateLandlordMutation(
            landlord.landlordId, landlord.firstName, landlord.lastName,
            landlord.phoneNumber, landlord.email, landlord.propertyIds, 
            landlord.nextKinName, landlord.disbursementDate, landlord.kraPin,
            landlord.notes, landlord.nationalIdNumber, landlord.nextKinPhoneNumber
        )
        const formData = getFormData(query, action.payload.fileUpload);
        await FormDataRestClient.post(
            GRAPHQL_API, formData
        ).then((queryResult) => {
            if (queryResult.data.errors) {
                action = updateActionErrors(action, queryResult.data.errors);
            }else if(queryResult.data.data.updateLandlord.errorMessage){
                action = updateActionErrors(action, queryResult.data.data.updateLandlord.errorMessage);
            }else {
                action = ({
                    ...action,
                    payload: parseFetchLandlord({
                        ...queryResult.data.data.updateLandlord.landlord
                    })
                });
            }
        });
    } catch (error) {
        console.error(error);
        action = updateActionErrors(action, error)
    }
    return action;
}

const deleteLandlordMiddleware = async action => {
    let landlord = action.payload;
    try {
        await graphqlClient({
            data: {
                query: DeleteLandlordMutation(landlord.landlordId)
            }
        }).then((queryResult) => {
            if (queryResult.data.errors) {
                action = updateActionErrors(action, queryResult.data.errors);
            }
        });
    } catch (error) {
        console.error(error);
        action = updateActionErrors(action, error);
    }
    return action;
}

const fetchLandlordsMiddleware = async (action) =>{
    try {
        let landlords = {}
        let landlord=action.payload
        await graphqlClient({
            data: {
                query: GetLandlordsQuery()
            }
        }).then((queryResult) => {
            if (queryResult.data.errors) {
                action = updateActionErrors(action, queryResult.data.errors);
            } else {
                let result = queryResult.data.data.fetchLandlords;
                result.map((landlord) => (
                    landlords[landlord.id] = {
                        ...parseFetchLandlord(landlord)
                    }
                ))
                action = {
                    ...action,
                    payload: {
                        landlords
                    },
                };

            }
        })
    } catch (error) {
        console.error(error);
    }
    return action;
}

export const landlordsMiddleware = storeAPI => next => async action => {
    switch (action.type) {
        case ADD_LANDLORD:
            action = await addLandlordsMiddleware(action);
            break;
        case UPDATE_LANDLORD:
            action = await updateLandlordsMiddleware(action);
            break;
        case DELETE_LANDLORD:
            action = await deleteLandlordMiddleware(action);
            break;
        case FETCH_LANDLORDS:
            action = await fetchLandlordsMiddleware(action);
            break;
    }
    return next(action);
};